import React, { useState, useEffect } from "react";
import spetakleData from "./spetakleData";
import { useNavigate } from "react-router-dom";

const SPEKTAKLE_LINKS = {
  "Matecznik": "/spektakle/matecznik",
  "Pieśni Rzeki": "/spektakle/piesni-rzeki",
  "Dla mnie Bomba!!!": "/spektakle/dla-mnie-bomba",
  "Dom Posterunkowa 1 Supraśl": "/spektakle/dom-posterunkowa-1",
  "Pan Maluśkiewicz": "/spektakle/pan-maluskiewicz",
  "NOSFERATU – DZIENNIK ZARAZY": "/spektakle/nosferatu",
};

const Spetakle = () => {
  return (
    <div className="bg-[#0d0d0d] px-4 sm:px-8 lg:px-16 xl:px-40 py-16">
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-center text-white mb-3 tracking-widest uppercase">
        Spektakle
      </h1>
      <div className="w-16 h-px bg-red-500 mx-auto mb-14" />
      <div className="flex flex-wrap justify-center gap-6">
        {spetakleData.map((data, index) => (
          <CardComponent key={index} data={data} />
        ))}
      </div>
    </div>
  );
};

const CardComponent = ({ data }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <div
        className="relative h-96 w-full sm:w-64 rounded-xl overflow-hidden cursor-pointer group flex-shrink-0 border border-transparent hover:border-red-500/40 transition-all duration-300 shadow-lg"
        onClick={() => SPEKTAKLE_LINKS[data.title] ? navigate(SPEKTAKLE_LINKS[data.title]) : setOpen(true)}
      >
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
          style={{ backgroundImage: `url(${data.image})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
        <div className="absolute bottom-0 w-full px-4 pb-5 text-center">
          <p className="text-white font-semibold text-base leading-snug tracking-wide">
            {data.title}
          </p>
          <p className="text-red-400 text-xs mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 uppercase tracking-widest">
            Czytaj więcej
          </p>
        </div>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
        >
          <div className="absolute inset-0 bg-black/75 backdrop-blur-sm" />

          <div
            className="relative z-10 w-full max-w-xl max-h-[90vh] bg-[#161616] rounded-2xl overflow-hidden border border-white/10 shadow-2xl flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Hero image z gradientem przechodzącym w tło modalu */}
            <div className="relative h-56 flex-shrink-0">
              <img
                src={data.image}
                alt={data.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#161616] via-[#161616]/20 to-transparent" />

              <button
                onClick={() => setOpen(false)}
                className="absolute top-3 right-3 w-8 h-8 bg-black/60 hover:bg-black rounded-full flex items-center justify-center text-white/80 hover:text-white text-sm transition-colors"
                aria-label="Zamknij"
              >
                ✕
              </button>

              <div className="absolute bottom-0 left-0 right-0 px-6 pb-3">
                <h2 className="text-2xl md:text-3xl font-bold text-white tracking-wide leading-tight">
                  {data.title}
                </h2>
              </div>
            </div>

            {/* Treść */}
            <div className="overflow-y-auto flex-1 px-6 py-4">
              <p className="text-gray-300 leading-relaxed text-sm md:text-base">
                {data.content}
              </p>

              {data.aktorzy && data.aktorzy.length > 0 && (
                <div className="mt-6 pt-5 border-t border-white/10">
                  <p className="text-red-400 text-xs uppercase tracking-widest mb-4 font-semibold">
                    Twórcy
                  </p>
                  <ul className="space-y-2">
                    {data.aktorzy.map((aktor, i) => (
                      <li key={i} className="flex gap-3 text-sm">
                        <span className="text-gray-500 min-w-fit">
                          {aktor.role}{aktor.role ? ":" : ""}
                        </span>
                        <span className="text-gray-200">{aktor.name}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Stopka */}
            <div className="flex justify-end px-6 py-4 border-t border-white/10 flex-shrink-0">
              <button
                onClick={() => setOpen(false)}
                className="px-5 py-2 text-sm text-gray-400 border border-white/15 rounded-lg hover:border-red-500/60 hover:text-red-400 transition-all duration-200"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Spetakle;
